const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = "Financial"

const SalesExecutive = 'SalesExecutive'
const Logistics = 'Logistics'

const SupllierRegisterRoutes = [
  {
    path: '/suppliers/create',
    name: 'CreateSuppliers',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
    component: () => import('@/_backoffice/_registrations/components/supplier/CreateSupplierModels.vue')
  },

  {
    path: '/',
    name: 'Suppliers',
    redirect: 'brands_list',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
    component: () => import('@/_backoffice/_registrations/pages/Suppliers.vue'),
    children: [
      {
        path: '/brands_list',
        name: 'BrandsList',
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics],
        },
        component: () => import('@/_backoffice/_registrations/components/supplier/BrandsList.vue'),
        children: [
          {
            path: 'brand/:id',
            name: 'EditBrand',
            meta: { 
              auth: true,
              roles: [Director, SalesExecutive, Manager, Logistics],
            },
            component: () => import('@/_backoffice/_registrations/components/supplier/brands/EditBrand.vue'),
            children: [
              {
                path: 'product/:productId',
                name: 'EditBrandProduct',
                meta: {
                  auth: true,
                  roles: [Director, SalesExecutive, Manager, Logistics],
                },
                component: () => import('@/_backoffice/_registrations/components/supplier/products/EditProduct.vue')
              },
            ]
          },
          {
            path: 'pickup_location/:id',
            name: 'EditPickupLocation',
            meta: { 
              auth: true,
              roles: [Director, SalesExecutive, Manager, Logistics],
            },
            component: () => import('@/_backoffice/_registrations/components/supplier/brands/EditPickupLocation.vue')
          },
          {
            path: 'product_pickup_location/:id',
            name: 'EditProductPickupLocation',
            meta: { 
              auth: true,
              roles: [Director, SalesExecutive, Manager, Logistics],
            },
            component: () => import('@/_backoffice/_registrations/components/supplier/brands/EditProductPickupLocation.vue')
          },
        ]
      },

      {
        path: '/products_list',
        name: 'ProductsList',
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics],
        },
        component: () => import('@/_backoffice/_registrations/components/supplier/ProductsList.vue'),
        children: [
          {
            path: 'product/:id',
            name: 'EditProduct',
            meta: { 
              auth: true,
              roles: [Director, SalesExecutive, Manager, Logistics],
            },
            component: () => import('@/_backoffice/_registrations/components/supplier/products/EditProduct.vue')
          },
        ]
      }
    ]
  }

]


export default SupllierRegisterRoutes
